import React from 'react'
import styled from 'styled-components'
import { theme } from '../../theme/theme'

const StyledFormIcon = styled.div`
  display: flex;
  justify-content: center;
  padding: ${theme.spacing.sm};
  color: ${({ theme }) => theme.colors.textMuted};
`

interface FormIconProps {
  children: React.ReactNode
  className?: string
}

export const FormIcon: React.FC<FormIconProps> = ({ children, className }) => {
  return <StyledFormIcon className={className}>{children}</StyledFormIcon>
}
